const toHex = (c: number) =>
  c == 0 || Number.isNaN(c)
    ? "00"
    : Math.round(c).toString(16).padStart(2, "0");

export const adjustBrightness = (
  color: string = "#ffffff",
  percent: number = 20
): string => {
  return color.replace(/\w\w/g, color =>
    toHex(
      Math.min(
        Math.max(
          0,
          Number.parseInt(color, 16) +
            Math.round((Number.parseInt(color, 16) / 100) * percent)
        ),
        255
      )
    )
  );
};

const convertToHex = (rgb: number[]) =>
  rgb.reduce((acc, cur) => acc + toHex(cur), "");

const trim = (s: string = "") => s.replace("#", "");

const convertToRGB = (hex: string) => {
  const color: number[] = [];
  color[0] = Number.parseInt(trim(hex).substring(0, 2), 16);
  color[1] = Number.parseInt(trim(hex).substring(2, 4), 16);
  color[2] = Number.parseInt(trim(hex).substring(4, 6), 16);
  return color;
};

export const generateGradient = (
  colorStart: string,
  colorEnd: string,
  gradientStopsCount: number
): string[] => {
  const start = convertToRGB(colorStart);
  const ensuredEndColor = colorEnd
    ? colorEnd
    : adjustBrightness(colorStart, -80);
  const end = convertToRGB(ensuredEndColor);

  const len = gradientStopsCount - 1;
  let alpha = 0;

  const gradient: string[] = [trim(ensuredEndColor)];

  for (let i = 0; i < len; i++) {
    alpha += 1 / len;

    const point: number[] = [
      start[0] * alpha + (1 - alpha) * end[0],
      start[1] * alpha + (1 - alpha) * end[1],
      start[2] * alpha + (1 - alpha) * end[2]
    ];

    gradient.push(convertToHex(point));
  }

  return gradient;
};
